import $ from 'jquery';

$(window).resize(function(){
    let headerBanner = $('.archive-heading div');

    if ($(window).width() < 1200) {
        headerBanner.removeClass("container");
} else if($(window).width() >= 1200){
        headerBanner.addClass("container");
    }
});

